export const STEP_REG			= 0
export const STEP_LOC			= 1
export const STEP_SPEC			= 2

export const FIRST_OBS_STEP		= 3
export const NUM_OBS_STEPS		= 5
export const MAX_STEP			= FIRST_OBS_STEP + NUM_OBS_STEPS - 1

export const TAGT_ALL_TIME_FIRST 	= 1
export const TAGT_YEAR_FIRST		= 2
export const TAGT_USER_FIRST		= 3
export const TAGT_USER_YEAR_FIRST	= 4

export const TAG_TGT_OBS		= 1
export const TAG_TGT_TAG		= 2
export const TAG_TGT_TAXON		= 3
export const TAG_TGT_GEO		= 4
export const TAG_TGT_MEDIA		= 5

export const TT_NONE			= 0
export const TT_SUBSPEC			= 1
export const TT_SPEC			= 2
export const TT_GENUS			= 3
export const TT_FAMILY			= 4
export const TT_ORDER			= 5

export const OE_NONE			= 0
export const OE_AUTH			= 1

export const JSP_MOD_USER		= 0x0001
export const JSP_ADD_USER		= 0x0002

export const EM_SELF			= 1
export const EM_NEW			= 2
export const EM_OTHER			= 3

export const CITY_ID_FORSSA 		= 17

export const COUNTRY_ID_FI		= 76;
export const COUNTRY_ID_NO		= 169;

export function ts() {
	return new Date();
}

export function dStr(unixT) {
	const  ts = new Date(unixT * 1000);
	return ts.getDate() + '.' + (ts.getMonth() + 1) + '.' + ts.getFullYear();
}

export const dateStr = (unixT) => {
	const  ts = new Date(unixT * 1000);
	return ts.getDate() + '.' + (ts.getMonth() + 1) + '.';
}

export function isoDStr(unixT) {
	let ts = new Date(unixT * 1000);
	return ts.toISOString().substring(0, 10);
}

export function pad(num, sz) {
	let s = "00" + num;
    	return s.substr(s.length - sz);
}

export function tStr(unixT) {
	let ts = new Date(unixT * 1000);
	return ts.getHours() + ':' + pad(ts.getMinutes(), 2);
}

export function unixNow() {
	return Math.round((new Date()).getTime() / 1000);
}

function maxDay(m, y) {
	return new Date(y, m, 0).getDate();
}

export function toUnixT(y, m, d, h, min) {
	return Math.round(new Date(y, m - 1, d, h, min).getTime() / 1000);
}

export function getMidnightEpoch(dt) {
	dt.setHours(0);
	dt.setMinutes(0);
	dt.setSeconds(0);
	dt.setMilliseconds(0);

	return dt.getTime() / 1000;
}

export function splitDate(str) {
	let res = str.split(".");
	
	if (!res || res.length !== 3) 
		return null;

	return res;
}

export function validDateStr(str) {
	let res = splitDate(str);
	if (!res) {
// 		console.log("invalid date format '" + str + "'");
		return false;
	}

	let m = parseInt(res[1], 10);
	if (m < 1 || m > 12) {
// 		console.log("Invalid month " + m);
		return false
	}

	let y = parseInt(res[2], 10);
	if (y < 1970 || y > new Date().getFullYear() + 1) {
// 		console.log("Invalid year " + y);
		return false;
	}

	let d = parseInt(res[0], 10);
	if (d < 1 || d > maxDay(m, y)) {
// 		console.log("Invalid day " + d);
		return false;
	}

	return true;
}

export function splitTime(str) {
	let res = str.split(":");
	
	if (!res || res.length !== 2) 
		return null;
	
	return res;
}

export function validTimeStr(str) {
	if (str.length <= 0) {
		console.error("zero length start time");
		return true;
	}

	let res = splitTime(str);
	if (!res) {
		console.error("invalid time format '" + str + "'");
		return false;
	}
	
	let h = parseInt(res[0], 10);
	if (isNaN(h) || h < 0 || h > 23) {
		console.error("invalid hour " + h);
		return false;
	}

	let min = parseInt(res[1], 10);
	if (isNaN(min) || min < 0 || min > 59) {
		console.error("invalid min " + min);
		return false;
	}

// 	console.log("hour " + h + ", min " + min);
	return true;
}

/* NOTE: str must be valid time! */
export function t2UnixT(str) {
	let res = str.split(":");
	return toUnixT(0, 0, 0, parseInt(res[0], 10), parseInt(res[1], 10));
}

export function alreadyInState(states, state) {
	let a = states.split(',');
	let i;
	
	for (i = 0; i < a.length; i++) {
		a[i] = a[i].trim();
		if (a[i] === state)
			return 1;
	}

	return 0;
	
}

export function stateIsValid(states, stateArr) {
	let a = states.split(',');
	let i;
	
	if (a.length < 1)
		return 0;

	for (i = 0; i < a.length; i++)
		a[i] = a[i].trim();

	let sa = a.slice().sort();
	let dup = [];
	
  	for (i = 0; i < sa.length - 1; i++) {
		if (sa[i + 1] === sa[i]) {
			dup.push(sa[i]);
		}
	}

	if (dup.length > 0) {
// 		console.log('Found ', dup.length, ' duplicates! ', dup);
		return 0;
	}

	for (i = 0; i < a.length; i++) {
		let found = 0;

		for (let j = 0; j < stateArr.length; j++) {
			if (a[i] === stateArr[j].state) {
				found = 1;
				break;
			}
		}

		if (!found) {
// 			console.log("stateIsValid: '" + a[i] + "' not found in state array!");
			return 0;
		}
	}

	return 1;
}

export function isalpha(c) {
	return (((c >= 'a') && (c <= 'z')) || ((c >= 'A') && (c <= 'Z')));
}

export function isdigit(c) {
	return ((c >= '0') && (c <= '9'));
}

export function isalnum(c) {
	return (isalpha(c) || isdigit(c));
}

export function latIsValid(str) {
	let lat = Number(str);

	if (isNaN(lat) || lat > 90.0 || lat < -90.0)
		return false;

	return true;
}

export function longIsValid(str) {
	let long = Number(str);

	if (isNaN(long) || long > 180.0 || long < -180.0)
		return false;

	return true;
}

export function c2js(c) {
	return '#' + c.toString(16);
}


export function delOfflineObs(id) {
	let off_d = window.localStorage.getItem('offline_obs');
	if (!off_d) 
		return 0;

	let found = 0;

	off_d = JSON.parse(off_d);

	for (const [ind, obs] of off_d.entries()) {
		if (obs.id === id) {
			off_d.splice(ind, 1);
			found = 1;
			break;
		}
	}

	if (found) {
		localStorage.setItem('offline_obs', JSON.stringify(off_d));
	} else {
		console.error('id', id, 'not found in offline obs!');
	}

	return 0;
}

export function LightenColor(color, percent) {
	let num = parseInt(color.replace('#', ''), 16);
	let amt = Math.round(2.55 * percent);
	let R = (num >> 16) + amt;
	let B = ((num >> 8) & 0x00FF) + amt;
	let G = (num & 0x0000FF) + amt;

	return '#' + (0x1000000 + (R<255?R<1?0:R:255)*0x10000 + (B<255?B<1?0:B:255)*0x100 + (G<255?G<1?0:G:255)).toString(16).slice(1);
};

export function DarkenColor(color, percent) {
	let num = parseInt(color.replace('#', ''), 16);
	let amt = Math.round(2.55 * percent);
	let R = (num >> 16) - amt;
	let B = ((num >> 8) & 0x00FF) - amt;
	let G = (num & 0x0000FF) - amt;

	return '#' + (0x1000000 + (R<255?R<1?0:R:255)*0x10000 + (B<255?B<1?0:B:255)*0x100 + (G<255?G<1?0:G:255)).toString(16).slice(1);
};
